import React from 'react';
import { ArrowUp, Github, Linkedin, Twitter, Mail } from 'lucide-react';

const Footer: React.FC = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <footer className="relative bg-gray-950 border-t border-purple-900/20 pt-12 pb-6 overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black to-gray-950"></div>
        <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-purple-500 to-transparent opacity-30"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <div className="h-8 w-8 rounded-full bg-gradient-to-r from-purple-600 to-blue-600 flex items-center justify-center mr-2">
                <span className="font-bold text-white">S</span>
              </div>
              <span className="font-orbitron text-xl text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-blue-500">
                SRIVARUN
              </span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Passionate software engineer with expertise in AI, machine learning, and distributed systems. Building scalable Generative AI applications that solve real-world business problems.
            </p>
            <div className="flex space-x-4">
              <a href="https://github.com/samayasri27" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-purple-400 transition-colors">
                <Github className="h-5 w-5" />
              </a>
              <a href="https://www.linkedin.com/in/srivarun05" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
              {/* <a href="#" className="text-gray-400 hover:text-indigo-400 transition-colors">
                <Twitter className="h-5 w-5" />
              </a> */}
              <a href="mailto:samayasri2005@gmail.com" className="text-gray-400 hover:text-purple-400 transition-colors">
                <Mail className="h-5 w-5" />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="font-orbitron text-white text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#home" className="hover:text-purple-400 transition-colors">Home</a>
              </li>
              <li>
                <a href="#about" className="hover:text-purple-400 transition-colors">About</a>
              </li>
              <li>
                <a href="#projects" className="hover:text-purple-400 transition-colors">Projects</a>
              </li>
              <li>
                <a href="#skills" className="hover:text-purple-400 transition-colors">Skills</a>
              </li>
              <li>
                <a href="#experience" className="hover:text-purple-400 transition-colors">Experience</a>
              </li>
              <li>
                <a href="#contact" className="hover:text-purple-400 transition-colors">Contact</a>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-orbitron text-white text-lg mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="mailto:samayasri2005@gmail.com" className="hover:text-purple-400 transition-colors">samayasri2005@gmail.com</a>
              </li>
              <li>
                <a href="tel:+919108818133" className="hover:text-purple-400 transition-colors">+91 9108818133</a>
              </li>
              <li>
                <span>Bangalore, Karnataka</span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
             {new Date().getFullYear()} S.SRIVARUN
          </p>
          <button
            onClick={scrollToTop}
            className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-800 hover:bg-gray-700 text-gray-400 hover:text-white transition-colors"
          >
            <ArrowUp className="h-5 w-5" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;